import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SettingsState, SettingsStore } from './settings.store';
import { Query } from '@datorama/akita';
import { Theme } from '@nft-folks/interfaces';

@Injectable({ providedIn: 'root' })
export class SettingsQuery extends Query<SettingsState> {
  constructor(protected override store: SettingsStore) {
    super(store);
  }
  readonly isMobile$ = this.select('isMobile');
  readonly showLoader$ = this.select('showLoader');
  readonly language$ = this.select('language');
  readonly isDark$: Observable<boolean> = this.select('theme').pipe(
    map((theme) => theme === Theme.DARK),
  );
  readonly theme$ = this.select('theme');

  get theme(): Theme {
    return this.getValue().theme;
  }

  get isDark(): boolean {
    return this.theme === Theme.DARK;
  }
  get isMobile(): boolean {
    return this.getValue().isMobile;
  }
}
